import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SysDigConfigListing from './SysDigConfigListing'
import SysDigCredentialsForm from './SysDigCredentialsForm'

export default function SysDigPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SysDigCredentialsForm}
            PullConfigListingView={SysDigConfigListing}
        />
    )
}
